import React from 'react';
import {
  IconButton,
  TextField,
  InputAdornment
} from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';
import { DIMENSIONS } from '../../constants';

function LabelWithInfo({ label, onInfo, testId }) {
  return (
    <>
      {label}
      <IconButton
        icon={Info}
        buttonSize="tight"
        color="info"
        edge="end"
        data-testid={testId}
        aria-label={`${label} info`}
        onClick={onInfo}
      />
    </>
  );
}

export default function DimensionsForm({
  dimensions,
  handleDimensionChange,
  onChangeInfo,
  setDrawerIndex,
  setDrawerInfoIcon,
  invalidFields = [],
  showGlobalError = false,
  trailingActions = null
}) {
  const openInfo = (index) => {
    onChangeInfo();
    setDrawerIndex(index);
    setDrawerInfoIcon(true);
  };

  const hasError = (field) => invalidFields.includes(field);

  return (
    <div className="sui-w-full">
      <div className="sui-flex sui-flex-wrap sui-flex-row sui-items-end sui-gap-x-2 sm:sui-gap-x-4">
        {DIMENSIONS.map(({ key, label, placeholder, drawerIndex }) => (
          <div key={key} className="sui-flex-1">
            <TextField
              placeholder={placeholder}
              value={dimensions[key]}
              name={label}
              onChange={(e) => handleDimensionChange(key, e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">in.</InputAdornment>
                ),
                ...label
          }}
              label={
                <span className="sui-text-danger-strong">
                  <LabelWithInfo
                    label={label}
                    onInfo={() => openInfo(drawerIndex)}
                    testId={`fit-compatibility-${key}-info`}
                  />
                </span>
              }
              status={hasError(key) ? 'error' : undefined}
            />
          </div>
        ))}
        {trailingActions}
      </div>
      {showGlobalError && (
        <div className="sui-mt-2 sui-text-sm sui-text-red-700 sui-font-normal">
          All fields must be filled out in order to proceed
        </div>
      )}
    </div>
  );
}